import React, { useEffect, useState, useMemo, useRef } from "react"
import { listApi } from "../../../../services/Admin/request"
import {addProviderRecord, deleteProviderRecord, exportTransaction} from "../../../../services/Admin/providerrecod"
import { apiGetMediaElement } from "../../../../services/Admin/media";
import TableC from "../../../../components/Admin/TableC"
import timestampToDate from "../../../../components/timestampToDate"
import {Grid, Box, Button, Link} from "@mui/material"
import LoadingProgress from "../../../../components/LoadingProgress"
import {RouteAdmin} from "../../../../routes/RouteAdmin"
import {Stack, CircularProgress, Modal} from "@mui/material"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import {showProviderApi} from "../../../../services/Admin/provider"
import { id } from "date-fns/locale"
import { set, setDate } from "date-fns"
import { number } from "yup"
import { t } from "i18next"
import { getMimeTypeByFormat } from "../../../../components/Admin/Media/mediaUtils";
import Card from "../../../../components/Admin/Card";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    width: 600,
    borderRadius: 3,
    position: "relative"
};


export default function Management() {

    const [transactions, setTransactions] = useState(null)
    const [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false)
    const [openExport, setOpenExport] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgSuccessExport, setMsgSuccessExport] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [msgDangerModal, setMsgDangerModal] = useState(null)
    const [spiner, setSpiner] = useState(false)
    const [spinerModal, setSpinerModal] = useState(false)
    const [dateBill, setDateBill] = useState()
    const [numFactura, setNumFactura] = useState("")
    const [totalFactura, setTotalFactura] = useState("")
    const [iva, setIva] = useState("")
    const [baseImponible, setBaseImponible] = useState("")
    const [irpf, setIrpf] = useState("")
    const [totalIrpf, setTotalIrpf] = useState("")
    const [invoicePdf, setInvoicePdf] = useState(null)
    const [fichero, setFichero] = useState(null)

    const [listProviders, setListProviders] = useState([])
    const [defaultProviderValueList, setDefaultProviderValueList] = useState({})
    const [idProvider, setIdProvider] = useState(null)
    const [isProviderSelect, setIsProviderSelect] = useState(false)
    const timeoutRef = useRef(null)

    const [dateExportStart, setDateExportStart] = useState()
    const [dateExportEnd, setDateExportEnd] = useState()
    const [msgDangerModalExport, setMsgDangerModalExport] = useState(null)
    const [spinerModalExport, setSpinerModalExport] = useState(false)

    const [idRecordDelete, setidRecordDelete] = useState(null)
    const [spinerModalDelete, setSpinerModalDelete] = useState(false)
    const [msgSuccessDelete, setMsgSuccessDelete] = useState(false)

    const [globalFilter, setGlobalFilter] = useState("")

    const handleOpen = () =>{ 
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setSpiner(false)
        setSpinerModal(false)
        setDateBill("")
        setNumFactura("")
        setTotalFactura("")
        setIva("")
        setBaseImponible("")
        setIrpf("")
        setTotalIrpf("")
        setDefaultProviderValueList(null)
        setIdProvider(null)
        setIsProviderSelect(false)
        setInvoicePdf(null)
        setFichero(null)
        setOpen(true)
    }

    const handleClose = () => setOpen(false)
    
    const handleOpenExport = () =>{
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setMsgSuccessExport(false)
        setMsgDangerModalExport(null)
        setSpinerModalExport(false)
        setDateExportStart("")
        setDateExportEnd("") 
        setOpenExport(true)
    }
    const handleCloseExport = () => setOpenExport(false)

    const columns = useMemo(
        () => [
            {
                Header: "FECHA",
                accessor: "date",
            },
            {
                Header: "NUMERO FACTURA",
                accessor: "numFactura",
            },
            {
                Header: "CIF",
                accessor: "nif",
            },
            {
                Header: "PROVEEDOR",
                accessor: "provider",
            },
             {
                Header: "BASE IMPONIBLE",
                accessor: "baseImponible",
            },
            {
                Header: "IVA (21%)",
                accessor: "iva",
            },
            {
                Header: "IRPF (%)",
                accessor: "irpf",
            },
            {
                Header: "TOTAL IRPF",
                accessor: "totalIrpf",
            },
            {
                Header: "TOTAL FACTURA",
                accessor: "totalFactura",
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }
        ],
        []
    )

    useEffect(() => {
        getProviderRecords()
        getProviders()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getProviderRecords = async () =>{
        setLoading(true)
        listApi("provider-record").then(resp => {
            
            let temp=null
           
            temp = resp.data.data.map((doc) => {
                let hrefProvider = `${RouteAdmin.PROVIDER_EDIT.path}/${doc.idProvider}`
            
                return {
                    ...doc,
                    date: timestampToDate(doc.date, false),
                    numFactura: doc.numFactura,
                    nif: doc.nif,
                    provider: `${doc.name}`,
                    baseImponible: doc.baseImponible,
                    iva: doc.iva,
                    irpf: doc.irpf,
                    totalIrpf: doc.totalIrpf,
                    totalFactura: doc.totalFactura,
                    id: doc.id,
                    actions: (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            { doc.file && doc.file !== "" &&
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={() => handleDownload(doc.file, `${doc.numFactura}.pdf`)}
                                    target="_blank"
                                    sx={{
                                        borderRadius: 2,
                                        paddingLeft: 2,
                                        paddingRight: 2,
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        boxShadow: 'none'
                                    }}
                                >
                                    Factura
                                </Button>
                            }
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                href={hrefProvider}
                                sx={{
                                    borderRadius: 2,
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    boxShadow: 'none'
                                }}
                            >
                                Proveedor
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => openModalDeleteRecord(doc.id)}
                                sx={{
                                    borderRadius: 2,
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    boxShadow: 'none'
                                }}
                            >
                                Eliminar
                            </Button>
                        </div>
                    )
                }
            })
                setTransactions(temp)
                setLoading(false)
            }).catch(error => {
                setLoading(false)
                console.error(error)
            })
        }

    const openModalDeleteRecord = (id) => {
        setidRecordDelete(id)
        setOpenDelete(true)
        setSpinerModalDelete(false)
        setMsgSuccessDelete(false)
        setMsgDanger(null)
    }

    const closeModalDeleteRecord = () => {
        setidRecordDelete(null)
        setOpenDelete(false)
        setSpinerModalDelete(false)
        setMsgSuccessDelete(false)
        setMsgDanger(null)
    }

    const deleteRecord = async (id) => {
        setSpinerModalDelete(true)
        setMsgSuccessDelete(false)
        setMsgDanger(null)
        deleteProviderRecord(idRecordDelete).then(resp => {
            setSpinerModalDelete(false)
            setMsgSuccessDelete(true)
            setidRecordDelete(null)
            setOpenDelete(false)
            setTimeout(() => {
                getProviderRecords()
            }, 1500)
        }).catch(err => {
            setMsgDanger(err.response.data?.msg)
            setSpinerModalDelete(false)
            setidRecordDelete(null)
            setOpenDelete(false)
        }) 
    }
        
    // Lista con todos los proveedores de la plataforma
    const getProviders = async () => {
        showProviderApi().then(resp => {
            if (resp.data.status) {
                const temp = resp.data.data.map((doc) => {
                    return {
                        id: doc.id,
                        ...doc,
                    }
                })
                setListProviders(temp)
            }
        })
    }

    const changeProvider = (event, value) => {
        if (value !== null) {
            setIdProvider(value.id)
            setDefaultProviderValueList({
                id: value.id,
                name: value.name,
                nif: value.nif,
                irpf: value.irpf,
            })
            setIsProviderSelect(true)

            const irpfPercent = parseFloat(value.irpf)
            if (!isNaN(irpfPercent)) {
                setIrpf(irpfPercent)
            } else {
                setIrpf("")
            }

            const base = parseFloat(baseImponible)
            const ivaValue = parseFloat(iva)

            if (!isNaN(base)) {
                if (!isNaN(irpfPercent)) {
                    const totalIrpfValue = base * (irpfPercent / 100)
                    setTotalIrpf(totalIrpfValue.toFixed(2))

                    const totalFactura = base + ivaValue - totalIrpfValue
                    setTotalFactura(totalFactura.toFixed(2))
                } else {
                    setTotalIrpf("")
                    const totalFactura = base + ivaValue
                    setTotalFactura(totalFactura.toFixed(2))
                }
            }
        } else {
            removeProvider()
        }
    }


    const removeProvider = () => {
        setDefaultProviderValueList(null)
        setIsProviderSelect(false)
        setIdProvider(null)
        setIrpf("")
        setBaseImponible("")
        setTotalIrpf("")
        setIva("")
        setTotalFactura("")
    }

    const handleChageDate = (event, value) => {
        setDateBill(event.target.value)
    }

    const handleChangeBaseImponible = (value) => {
        const base = parseFloat(value)
        const irpfPercent = parseFloat(irpf)
        const ivaPercent = 21

        setBaseImponible(value)

        if (!isNaN(base)) {
            const ivaValue = (base * (ivaPercent / 100))
            setIva(ivaValue.toFixed(2))

            if (!isNaN(irpfPercent)) {
                const totalIrpfValue = (base * (irpfPercent / 100))
                setTotalIrpf(totalIrpfValue.toFixed(2))

                const totalFactura = base + ivaValue - totalIrpfValue
                setTotalFactura(totalFactura.toFixed(2))
            } else {
                const totalFactura = base + ivaValue
                setTotalFactura(totalFactura.toFixed(2))
            }
        } else {
            // Reset values if input is invalid
            setIva("")
            setTotalIrpf("")
            setTotalFactura("")
        }
    }


    const createInvoice = async () => {
        setMsgDanger(null)
        setMsgDangerModal(null)
        setInvoicePdf(null)
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setSpiner(true)

        if (!dateBill) {
            setMsgDangerModal(["Debe seleccionar una fecha de emisión para la factura."])
            setSpiner(false)
            return
        }

        if (idProvider === null || idProvider === undefined) {
            setMsgDangerModal(["Debe seleccionar un proveedor para la factura."])
            setSpiner(false)
            return
        }

        if(!numFactura || numFactura.trim() === "") {
            setMsgDangerModal(["Debe introducir el número de factura."])
            setSpiner(false)
            return
        }

        if (!baseImponible || baseImponible.trim() === "") {
            setMsgDangerModal(["Debe introducir la base imponible para la factura"])
            setSpiner(false)
            return
        }

        const formData = new FormData()
        formData.append("file", fichero)  // fichero es un objeto File de input type="file"
        formData.append("dateBill", dateBill)
        formData.append("idProvider", idProvider)
        formData.append("baseImponible", baseImponible)
        formData.append("numFactura", numFactura)
        
        addProviderRecord(formData).then(resp => {
            if (resp.data.status) {
                setMsgSuccess(true)
                setTimeout(() => {
                   getProviderRecords()
                }, 1500)
            } else {
                setMsgDanger(resp.data?.errors)
            }
            setOpen(false)
            setSpiner(false)
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
            setOpen(false)
            setSpiner(false)
        })
    }

    const createExport = async () => {
        setMsgDangerModalExport(null)
        setSpinerModalExport(true)
        setMsgDanger(null)
        setMsgSuccess(false)
        setMsgSuccessExport(false)

        if (!dateExportStart) {
            setMsgDangerModalExport(["Debe seleccionar una fecha de inicio para la exportación."])
            setSpinerModalExport(false)
            return
        }

        if (!dateExportEnd) {
            setMsgDangerModalExport(["Debe seleccionar una fecha de fin para la exportación."])
            setSpinerModalExport(false)
            return
        }

        try {
            const response = await exportTransaction({
                dateExportStart,
                dateExportEnd
            })

            const contentType = response.headers['content-type']

            if (contentType.includes('application/json')) {
                // La respuesta es JSON => error
                const text = await response.data.text() // response.data es Blob
                const json = JSON.parse(text)
                setMsgDanger(json.errors || ["Error desconocido en la exportación."])
                handleCloseExport()
            } else {

                // Crear enlace de descarga
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob)

                const link = document.createElement('a')
                link.href = url

                const now = new Date()
                const formattedDate = now.toISOString().slice(0, 19).replace(/[-:T]/g, '')
                const filename = `proveedores_facturas_export_${formattedDate}.xlsx`
                link.download = filename


                document.body.appendChild(link)
                link.click()
                link.remove()

                setOpenExport(false)
                setMsgSuccessExport(true)
            }
        } catch (err) {
            setMsgDanger(["Error al generar el fichero de exportación."])
            console.error(err)
        }

        setSpinerModalExport(false)
    }

    const handleDownload = (file, filename) => {
        if (file) {
            // Si inicialmente inicia con https
            if (file.startsWith("https")) {
                window.open(file, "_blank")
                return
            }
            apiGetMediaElement(file).then(resp => {
                const base64Content = resp.data?.content;
                const format = 'pdf';
                if (base64Content) {
                    const filenameIn = filename || `archivo.${format || "pdf"}`;
                    const mimeType = getMimeTypeByFormat(format);
                    const link = document.createElement("a");
                    link.href = `data:${mimeType};base64,${base64Content}`;
                    link.download = filenameIn;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
    };

    // --- Filtro global aplicado a transactions ---
    const filteredTransactions = useMemo(() => {
        if (!globalFilter) return transactions || [];
        const search = globalFilter.toLowerCase();
        return (transactions || []).filter(row =>
            Object.values(row).some(
                val =>
                    typeof val === 'string' && val.toLowerCase().includes(search)
            )
        );
    }, [transactions, globalFilter]);

    return (
        <Card>
            <div className="cointainer cointainer-bt">
                <h1>Gestión de proveedores</h1>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%' }}>
                    <Button
                        onClick={handleOpenExport}
                        color="primary"
                        variant="outlined"
                        style={{ width: 200 }}
                    >
                        Exportar
                    </Button>
                    <Button
                        onClick={handleOpen}
                        color="primary"
                        variant="outlined"
                        style={{ width: 200, marginLeft: "10px" }}
                    >
                        Guardar Factura
                    </Button>
                </div>
            </div>

            {msgSuccess && (
                <Box className="alert-success">
                    La factura se ha guardado correctamente.
                </Box>
            )}

            {msgSuccessExport && (
                <Box className="alert-success">
                    La exportación se ha generado correctamente
                </Box>
            )}

            {msgSuccessDelete && (
                <Box className="alert-success">
                    El registro se ha eliminado correctamente.
                </Box>
            )}

            {msgDanger && (
                <Box className="alert-danger">
                    {msgDanger.map((item,index) => {
                        return (<span key={index}>{item} <br/></span>)
                    })}
                </Box>
            )}

            <LoadingProgress loading={loading}/>
            {!loading && (
                <TableC
                    columns={columns}
                    data={filteredTransactions}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                />
            )}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Guardar Factura
                    </Typography>
                    {!spiner && (
                        <>
                            <Stack spacing={2} mt={2}>
                                <TextField
                                    name="dateBill"
                                    label="Día de emisión (Fecha)"
                                    variant="outlined"
                                    type="date"
                                    fullWidth
                                    onChange={handleChageDate}
                                    value={dateBill || []}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />

                                <Autocomplete
                                    options={listProviders}
                                    value={defaultProviderValueList}
                                    getOptionLabel={(option) => {
                                        if (Object.keys(option).length !== 0) {
                                            return `${option.name} - ${option.nif}`
                                        } else {
                                            return ""
                                        }
                                    }}
                                    fullWidth
                                    size="small"
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label="* Proveedor"
                                        variant="outlined"
                                        name="idProvider"
                                        InputLabelProps={{shrink: true}}
            
                                    />}
                                    getOptionSelected={(option, value) => option.value === value.value}
                                    onChange={changeProvider}
                                />

                                <TextField
                                    value={numFactura}
                                    onChange={(e) => setNumFactura(e.target.value)}
                                    variant="outlined"
                                    label="Número de Factura"
                                    name="numFactura"
                                    type="text"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />

                                <TextField
                                    value={baseImponible}
                                    onChange={(e) => handleChangeBaseImponible(e.target.value)}
                                    variant="outlined"
                                    label="Base Imponible (€)"
                                    name="baseImponible"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />

                                <TextField
                                    value={iva}
                                    onChange={(e) => setIva(e.target.value)}
                                    variant="outlined"
                                    label="IVA calculado al 21% (€)"
                                    name="iva"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true}
                                />
                                
                                 <TextField
                                    value={irpf}
                                    onChange={(e) => setIrpf(e.target.value)}
                                    variant="outlined"
                                    label="IRPF (%)"
                                    name="irpf"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true}
                                />

                                <TextField
                                    value={totalIrpf}
                                    onChange={(e) => setTotalIrpf(e.target.value)}
                                    variant="outlined"
                                    label="Total IRPF (€)"
                                    name="totalIrpf"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true}
                                />

                                <TextField
                                    value={totalFactura}
                                    onChange={(e) => setTotalFactura(e.target.value)}
                                    variant="outlined"
                                    label="Importe TOTAL de la Factura (€)"
                                    name="totalFactura"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true}
                                />

                                <label htmlFor="upload-file">
                                <input
                                    style={{ display: 'none' }}
                                    id="upload-file"
                                    type="file"
                                    onChange={(e) => setFichero(e.target.files[0])}
                                />
                                <Button variant="outlined" component="span">
                                    Seleccionar archivo factura
                                </Button>
                                </label>
                                {fichero && <span>{fichero.name}</span>}

                                 {msgDangerModal && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className="alert-danger">
                                            {msgDangerModal.map((item,index) => {
                                                return (<span key={index}>{item} <br/></span>)
                                            })}
                                        </Box>
                                    </Grid>
                                )}
                                

                                <Stack direction="row" justifyContent="space-between">
                                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                                        <div style={{ width: "50%" }}>
                                            <Button
                                                onClick={handleClose}
                                                variant="contained"
                                                className="MuiButton-containedCancel"
                                                fullWidth
                                            >
                                                Cancelar
                                            </Button>
                                        </div>
                                        <div style={{ width: "50%" }}>
                                            <Button
                                                onClick={createInvoice}
                                                color="primary"
                                                variant="contained"
                                                fullWidth
                                            >
                                                Guardar
                                            </Button>
                                        </div>
                                    </div>
                                </Stack>
                            </Stack>
                        </>
                    )}

                    {spiner && (
                        <>
                            <br/>
                            <br/>
                            <br/>
                            <CircularProgress color="success"/>
                            <br/>
                            <br/>
                            <br/>
                        </>
                    )}
                </Box>
            </Modal>
            <Modal
                open={openExport}
                onClose={handleCloseExport}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Exportar Facturas Proveedores
                    </Typography>
                    {!spinerModalExport && (
                        <>
                            <Typography id="modal-modal-description" sx={{mt: 2}}>
                                Seleccione un rango de fechas:
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <div className="mt-2">
                                        <TextField
                                            name="dateExportStart"
                                            label="Desde"
                                            variant="outlined"
                                            type="date"
                                            format="dd/MM/yyyy"
                                            fullWidth
                                            onChange={(e) => setDateExportStart(e.target.value)}
                                            value={dateExportStart || []}
                                            InputLabelProps={{shrink: true}}
                                            size="small"
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <div className="mt-2">
                                        <TextField
                                            name="dateExportEnd"
                                            label="Hasta"
                                            variant="outlined"
                                            type="date"
                                            format="dd/MM/yyyy"
                                            fullWidth
                                            onChange={(e) => setDateExportEnd(e.target.value)}
                                            value={dateExportEnd || []}
                                            InputLabelProps={{shrink: true}}
                                            size="small"
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        {msgDangerModalExport && (
                            <Grid item xs={12} md={12} lg={12} mt={4}>
                                <Box className="alert-danger">
                                    {msgDangerModalExport.map((item,index) => {
                                        return (<span key={index}>{item} <br/></span>)
                                    })}
                                </Box>
                            </Grid>
                        )}
                            <Stack direction="row" justifyContent="space-between" mt={4}>
                                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                                    <div style={{ width: "50%" }}>
                                        <Button
                                            onClick={handleCloseExport}
                                            variant="contained"
                                            className="MuiButton-containedCancel"
                                            fullWidth
                                        >
                                            Cancelar
                                        </Button>
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <Button
                                            onClick={createExport}
                                            color="primary"
                                            variant="contained"
                                            fullWidth
                                        >
                                            Exportar
                                        </Button>
                                    </div>
                                </div>
                                
                            </Stack>
                        </>
                    )}
                    {spinerModalExport && (
                        <>
                            <br/>
                            <br/>
                            <br/>
                            <CircularProgress color="success"/>
                            <br/>
                            <br/>
                            <br/>
                        </>
                    )}
                </Box>
            </Modal>
            <Modal
                open={openDelete}
                onClose={closeModalDeleteRecord}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Eliminar Registro
                    </Typography>
                    {!spinerModalDelete && (
                        <>
                            <Typography id="modal-modal-description" sx={{mt: 2}}>
                                Esta seguro que desea eliminar este registro?
                                <br/>Esta acción no se puede deshacer.
                            </Typography>

                            
                            <Stack direction="row" justifyContent="space-between" mt={4}>
                                <Button onClick={closeModalDeleteRecord}>Cancelar</Button>
                                <Button
                                    onClick={deleteRecord}
                                    color="primary"
                                    variant="contained"
                                >
                                    Eliminar
                                </Button>
                            </Stack>
                        </>
                    )}
                    {spinerModalDelete && (
                        <>
                            <br/>
                            <br/>
                            <br/>
                            <CircularProgress color="success"/>
                            <br/>
                            <br/>
                            <br/>
                        </>
                    )}
                </Box>
            </Modal>
        </Card>
    )
}
